<div class="notifications-container">
  <div class="notifications-header">
    <div class="header-content">
      <h2 class="page-title">
        <mat-icon class="title-icon">notifications</mat-icon>
        Notifications
        <span class="notification-count" *ngIf="totalNotifications > 0">{{totalNotifications}}</span>
      </h2>
      <div class="header-actions">
        <div class="filter-chips" role="tablist" aria-label="Notification filter">
          <button mat-button class="chip" [class.active]="filter==='all'" (click)="setFilter('all')"
            [attr.aria-selected]="filter==='all'">
            All
          </button>
          <button mat-button class="chip" [class.active]="filter==='unread'" (click)="setFilter('unread')"
            [attr.aria-selected]="filter==='unread'">
            Unread
          </button>
        </div>
        <button mat-icon-button class="action-btn" (click)="markAllAsRead()" *ngIf="notifications?.length > 0">
          <mat-icon>done_all</mat-icon>
          <span class="tooltip">Mark all as read</span>
        </button>
        <button mat-icon-button class="action-btn" (click)="refreshNotifications()">
          <mat-icon>refresh</mat-icon>
          <span class="tooltip">Refresh</span>
        </button>
      </div>
    </div>
  </div>

  <div class="notifications-content" infiniteScroll [infiniteScrollDistance]="1.5"
    [infiniteScrollContainer]="'.main-view'" [fromRoot]="true" (scrolled)="onScroll()">

    <div class="notification-card" *ngFor="let notification of filtered; trackBy: trackByNotification"
      [ngClass]="{'unread': !notification.read, 'read': notification.read}">

      <div class="notification-indicator">
        <div class="status-dot" *ngIf="!notification.read"></div>
      </div>

      <div class="notification-icon">
        <div class="icon-container" [ngClass]="getNotificationType(notification)">
          <mat-icon>{{getNotificationIcon(notification)}}</mat-icon>
        </div>
      </div>

      <div class="notification-body">
        <div class="notification-content" (click)="viewNotification(notification)">
          <div class="notification-text">{{notification?.notification}}</div>
          <div class="notification-time" *ngIf="notification.createdAt">
            {{notification.createdAt | date:'MMM dd, yyyy HH:mm'}}
          </div>
        </div>

        <div class="notification-actions">
          <button mat-icon-button class="action-btn" (click)="markAsRead(notification)" *ngIf="!notification.read"
            matTooltip="Mark as read">
            <mat-icon>check</mat-icon>
          </button>
          <button mat-icon-button class="action-btn delete-btn" (click)="deleteNotification(notification)"
            matTooltip="Delete notification">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="empty-state" *ngIf="noNotifications">
      <div class="empty-content">
        <div class="empty-icon">
          <mat-icon>notifications_none</mat-icon>
        </div>
        <h3 class="empty-title">No Notifications Yet!</h3>
        <p class="empty-description">
          When you receive notifications about assessments, they'll appear here.
        </p>
        <button mat-raised-button color="primary" class="refresh-btn" (click)="refreshNotifications()">
          <mat-icon>refresh</mat-icon>
          Refresh
        </button>
      </div>
    </div>

    <div class="loading-state" *ngIf="loading">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading notifications...</p>
    </div>
  </div>
</div>